import { Stack } from 'braid-design-system';
import React from 'react';

import { ContactUs } from 'src/app/views/components/ContactUs';
import { FaqSection } from 'src/app/views/sections/FaqSection';

export const FaqContactSection = () => (
  <Stack space="medium">
    <FaqSection />
    <ContactUs />
  </Stack>
);
